import { useState } from "react";
import { Link, useNavigate } from "react-router";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { CampoSenha } from "@/components/shared/campo-senha";
import { useAuth } from "@/lib/auth-context";
import { mensagemDeErro } from "./mensagem-de-erro";

export default function CadastroPage() {
  const { signUp } = useAuth();
  const navigate = useNavigate();
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [aSubmeter, setASubmeter] = useState(false);

  async function aoSubmeter(e: React.FormEvent) {
    e.preventDefault();
    setASubmeter(true);
    const { error } = await signUp({ email, password, fullName });
    setASubmeter(false);

    if (error) {
      toast.error(mensagemDeErro(error, "cadastro"), { duration: 8000 });
      return;
    }
    toast.success("Conta criada. Fica pendente de aprovação.");
    void navigate("/aguardando-aprovacao", { replace: true });
  }

  return (
    <div className="flex min-h-svh items-center justify-center p-6">
      <Card className="w-full max-w-sm">
        <CardHeader>
          <CardTitle>Criar conta</CardTitle>
          <CardDescription>
            Um administrador terá de aprovar o acesso e atribuir um projeto.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={aoSubmeter} className="grid gap-4">
            <div className="grid gap-2">
              <Label htmlFor="fullName">Nome completo</Label>
              <Input
                id="fullName"
                required
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
              />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="email">E-mail</Label>
              <Input
                id="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="password">Palavra-passe</Label>
              <CampoSenha
                id="password"
                autoComplete="new-password"
                minLength={8}
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <Button type="submit" disabled={aSubmeter}>
              {aSubmeter ? "A criar…" : "Criar conta"}
            </Button>
            <p className="text-muted-foreground text-center text-sm">
              Já tem conta?{" "}
              <Link to="/login" className="underline underline-offset-4">
                Entrar
              </Link>
            </p>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
